import { PrivateBankingProductCatalogueResponse, ServiceDefinitionNode } from '../eBankingTempTypes';

interface ProductRelation {
  relationType: string;
  child: PrivateBankingProductCatalogueResponse;
}

export type ProductRow = PrivateBankingProductCatalogueResponse & {
  _path: string[];
  _selectable: boolean;
  _isChild: boolean;
};

const byProductName = (a: PrivateBankingProductCatalogueResponse, b: PrivateBankingProductCatalogueResponse) =>
  (a.productName ?? '').localeCompare(b.productName ?? '');

/** Extends the Product catalogue response DTO with AG Grid tree-data metadata. */
export const mapProductsToTreeRows = (
  items: PrivateBankingProductCatalogueResponse[],
  parentPath: string[] = [],
): ProductRow[] => {
  return [...items].sort(byProductName).flatMap((item) => {
    const id = item.uid ?? item.productId;

    if (!id) return [];

    const isChild = parentPath.length > 0;
    const path = [...parentPath, id];

    const children = (
      item.children?.map((c) => c.child).filter((c): c is PrivateBankingProductCatalogueResponse => c !== undefined) ??
      []
    ).sort(byProductName);

    const row: ProductRow = {
      ...item,
      _path: path,
      _isChild: isChild,
      _selectable: !isChild && item.canBeAdded !== false && item.maxInstancesReached !== true,
    };

    return [row, ...mapProductsToTreeRows(children, path)];
  });
};

/**
 * Recursively flattens a nested product catalogue into AG Grid tree rows.
 */
export const mapProductToServiceDefinitionNode = (
  product: PrivateBankingProductCatalogueResponse,
): ServiceDefinitionNode => {
  return {
    serviceDefinitionId: product.uid,
    children: (product.children ?? [])
      .filter((c): c is ProductRelation & { child: PrivateBankingProductCatalogueResponse } => c.child !== undefined)
      .map((c) => mapProductToServiceDefinitionNode(c.child)),
  };
};
